import {Link} from "react-router-dom";
import logo from "../assets/img/logo.svg";
function Logo (){
  return(
    <Link id="Logo" to="/" className="col-3">
        <img src={logo} alt="logo"/>
    </Link>
  )
}

export default Logo;